import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightToBracket } from "@fortawesome/free-solid-svg-icons";
import VerifyLoginOTP from "../../components/modals/auth/VerifyLoginOTP";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import axios from "axios";
import platform from "platform";
import { toast } from "react-toastify";
import { login } from "../../redux/actions/auth";

const SignIn = () => {
  const dispatch = useDispatch()
  const { loading, otpRequired } = useSelector((state) => state.auth);
  const [open, setOpen] = useState(true)
  const [userName, setUserName] = useState('')
  const [ip, setIp] = useState('')
  const [password, setPassword] = useState('')
  // const [showPassword, setShowPassword] = useState(false);
  const [browserName, setBrowserName] = useState("");


  const getData = async () => {
    const res = await axios.get("https://api.ipify.org/?format=json").catch((errr) => {
      // console.log(errr);
    });
    // console.log(res.data);
    setIp(res.data.ip);
  }; 

  useEffect(() => {
    setBrowserName(platform.name);
    getData();
  }, [dispatch])

  const toggleSignWithOtpModal = () => {
    setOpen(!open)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if(!userName || !password) {
      toast.error('Username or Password is Require')
    }else{
      dispatch(login({
        ip,
        browserName,
        username: userName,
        password,
      }))
    }
  };


  return (
    <div className="m-0 font-sans antialiased font-normal bg-white text-start text-base leading-default text-slate-500">
      <div className="container sticky top-0 z-sticky">
        <div className="flex flex-wrap -mx-3">
          <div className="w-full max-w-full px-3 flex-0">
            <nav className="absolute top-0 left-0 right-0 z-30 flex flex-wrap items-center px-4 py-2 mx-6 my-4 shadow-soft-2xl rounded-blur bg-white/80 backdrop-blur-2xl backdrop-saturate-200 lg:flex-nowrap lg:justify-start">
              <div className="flex items-center justify-between w-full p-0 pl-6 mx-auto flex-wrap-inherit">
                <a
                  className="py-2.375 text-sm mr-4 ml-4 whitespace-nowrap font-bold text-primary lg:ml-0"
                  href="/"
                >
                  {" "}
                  AccessBank Liberia{" "}
                </a>
                <button
                  navbar-trigger
                  className="px-3 py-1 ml-2 leading-none transition-all bg-transparent border border-transparent border-solid rounded-lg shadow-none cursor-pointer text-lg ease-soft-in-out lg:hidden"
                  type="button"
                  aria-controls="navigation"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="inline-block mt-2 align-middle bg-center bg-no-repeat bg-cover w-6 h-6 bg-none">
                    <span
                      bar1
                      className="w-5.5 rounded-xs relative my-0 mx-auto block h-px bg-primary-light transition-all duration-300"
                    ></span>
                    <span
                      bar2
                      className="w-5.5 rounded-xs mt-1.75 relative my-0 mx-auto block h-px bg-primary-light transition-all duration-300"
                    ></span>
                    <span
                      bar3
                      className="w-5.5 rounded-xs mt-1.75 relative my-0 mx-auto block h-px bg-primary-light transition-all duration-300"
                    ></span>
                  </span>
                </button>
                <div
                  navbar-menu
                  className="items-center flex-grow overflow-hidden transition-all duration-500 ease-soft lg-max:max-h-0 basis-full lg:flex lg:basis-auto"
                >
                  <ul className="flex flex-col pl-0 mx-auto mb-0 list-none lg:flex-row xl:ml-auto">
                    {/* <li>
                      <a
                        className="flex items-center px-4 py-2 mr-2 font-normal transition-all lg-max:opacity-0 duration-250 ease-soft-in-out text-sm text-primary lg:px-2"
                        aria-current="page"
                        href="/"
                      >
                        <i className="mr-1 fa fa-chart-pie opacity-60"></i>
                        Loan Payment
                      </a>
                    </li>
                    <li>
                      <a
                        className="block px-4 py-2 mr-2 font-normal transition-all lg-max:opacity-0 duration-250 ease-soft-in-out text-sm text-primary lg:px-2"
                        href="/"
                      >
                        <i className="mr-1 fa fa-user opacity-60"></i>
                        Profile
                      </a>
                    </li>
                    <li>
                      <a
                        className="block px-4 py-2 mr-2 font-normal transition-all lg-max:opacity-0 duration-250 ease-soft-in-out text-sm text-primary lg:px-2"
                        href="/"
                      >
                        <i className="mr-1 fas fa-user-circle opacity-60"></i>
                        Sign Up
                      </a>
                    </li>
                    <li>
                      <a
                        className="block px-4 py-2 mr-2 font-normal transition-all lg-max:opacity-0 duration-250 ease-soft-in-out text-sm text-primary lg:px-2"
                        href="/"
                      >
                        <i className="mr-1 fas fa-key opacity-60"></i>
                        Sign In
                      </a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <main className="mt-0 transition-all duration-200 ease-soft-in-out">
        <section>
          <div className="relative flex items-center p-0 overflow-hidden bg-center bg-cover min-h-75-screen">
            <div className="container z-10">
              <div className="flex flex-wrap mt-0 -mx-3">
                <div className="flex flex-col w-full max-w-full px-3 mx-auto md:flex-0 shrink-0 md:w-6/12 lg:w-5/12 xl:w-4/12">
                  <div className="relative flex flex-col min-w-0 mt-32 break-words bg-transparent border-0 shadow-none rounded-2xl bg-clip-border">
                    <div className="p-6 pb-0 mb-0 bg-transparent border-b-0 rounded-t-2xl">
                      <h3 className="relative z-10 font-bold text-transparent bg-gradient-to-tl from-primary to-primary-light bg-clip-text">
                        Welcome back
                      </h3>
                      <p className="mb-0">
                        Enter your Username/phone number and password to sign in
                      </p>
                    </div>
                    <div className="flex-auto p-6">
                      <form>
                        <label className="mb-2 ml-1 font-bold text-xs text-primary">
                          Client Code / Mobile Number
                        </label>
                        <div className="mb-4">
                          <input
                            type="text"
                            className="focus:shadow-primary-dark text-sm leading-5.6 ease-soft block w-full appearance-none rounded-lg border border-solid border-gray-300 bg-white bg-clip-padding px-3 py-2 font-normal text-primary-dark transition-all focus:border-secondary-dark focus:outline-none focus:transition-shadow placeholder-secondary"
                            placeholder="Username/Mobile Number"
                            aria-label="Username/Mobile Number"
                            aria-describedby="email-addon"
                            onChange={(e) => setUserName(e.target.value)}
                          />
                        </div>
                        <label className="mb-2 ml-1 font-bold text-xs text-primary">
                          Password
                        </label>
                        <div className="mb-4">
                          <input
                            type="password"
                            className="focus:shadow-primary-dark text-sm leading-5.6 ease-soft block w-full appearance-none rounded-lg border border-solid border-gray-300 bg-white bg-clip-padding px-3 py-2 font-normal text-primary-dark transition-all focus:border-secondary-dark focus:outline-none focus:transition-shadow placeholder-secondary"
                            placeholder="Password"
                            aria-label="Password"
                            aria-describedby="password-addon"
                            onChange={(e) => setPassword(e.target.value)}
                          />
                        </div>
                        <a className="min-h-6 mb-0.5 block " href='/resetpassword'>
                          {/* <input id="rememberMe" className="mt-0.54 rounded-10 duration-250 ease-soft-in-out after:rounded-circle after:shadow-soft-2xl after:duration-250 checked:after:translate-x-5.25 h-5 relative float-left -ml-12 w-10 cursor-pointer appearance-none border border-solid border-gray-200 bg-slate-800/10 bg-none bg-contain bg-left bg-no-repeat align-top transition-all after:absolute after:top-px after:h-4 after:w-4 after:translate-x-px after:bg-white after:content-[''] checked:border-slate-800/95 checked:bg-slate-800/95 checked:bg-none checked:bg-right" type="checkbox" /> */}
                          <label
                            className="mb-2  font-normal cursor-pointer select-none text-sm text-primary"
                            htmlFor="rememberMe"
                          >
                            Reset Password
                          </label>
                        </a>
                        <div className="text-center">
                          <button
                          onClick={handleSubmit}
                            type="submit"
                            className="inline-block w-full px-6 py-3 mt-6 mb-0 font-bold text-center text-white uppercase align-middle transition-all bg-transparent border-0 rounded-lg cursor-pointer shadow-soft-md bg-x-25 bg-150 leading-pro text-xs ease-soft-in tracking-tight-soft bg-gradient-to-tl from-primary-dark to-primary hover:scale-102 hover:shadow-soft-xs active:opacity-85"
                          >

                            {loading ? <>loading ...</> : <><FontAwesomeIcon
                              icon={faRightToBracket}
                              className="mr-2"
                            />
                            Sign in</>}
                          </button>
                        </div>
                      </form>
                    </div>
                    {/* <div className="p-6 px-1 pt-0 text-center bg-transparent border-t-0 border-t-solid rounded-b-2xl lg:px-2">
                      <p className="mx-auto mb-6 leading-normal text-sm">
                        Don't have an account?
                        <a
                          href="../pages/sign-up.html"
                          className="relative z-10 font-semibold text-transparent bg-gradient-to-tl from-primary to-primary-light bg-clip-text"
                        >
                          Sign up
                        </a>
                      </p>
                    </div> */}
                  </div>
                </div>
                <div className="w-full max-w-full px-3 lg:flex-0 shrink-0 md:w-6/12">
                  <div className="absolute top-0 hidden w-3/5 h-full -mr-32 overflow-hidden -skew-x-10 -right-40 rounded-bl-xl md:block">
                    <div
                      className="absolute inset-x-0 top-10 z-0 h-full -ml-16 bg-contain skew-x-10"
                      style={{
                        backgroundImage: `url("/assets/img/accessBankBanner.jpg")`,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <footer className="py-12">
        <div className="container">
          <div className="flex flex-wrap -mx-3">
            <div className="flex-shrink-0 w-full max-w-full mx-auto mb-6 text-center lg:flex-0 lg:w-8/12">
              {/* <a
                href="/"
                target="_blank"
                className="mb-2 mr-4 text-primary-dark sm:mb-0 xl:mr-12"
              >
                {" "}
                Website{" "}
              </a>
              <a
                href="/"
                target="_blank"
                className="mb-2 mr-4 text-primary-dark sm:mb-0 xl:mr-12"
              >
                {" "}
                About Us{" "}
              </a>
              <a
                href="/"
                target="_blank"
                className="mb-2 mr-4 text-primary-dark sm:mb-0 xl:mr-12"
              >
                {" "}
                Team{" "}
              </a> */}
              {/* <a
                href="/"
                target="_blank"
                className="mb-2 mr-4 text-primary-dark sm:mb-0 xl:mr-12"
              >
                {" "}
                Products{" "}
              </a>
              <a
                href="/"
                target="_blank"
                className="mb-2 mr-4 text-primary-dark sm:mb-0 xl:mr-12"
              >
                {" "}
                Contact{" "}
              </a> */}
            </div>
            <div className="flex-shrink-0 w-full max-w-full mx-auto mt-2 mb-6 text-center lg:flex-0 lg:w-8/12">
              <a href="/" target="_blank" className="mr-6 text-primary-dark">
                <span className="text-lg fab fa-dribbble"></span>
              </a>
              <a href="/" target="_blank" className="mr-6 text-primary-dark">
                <span className="text-lg fab fa-twitter"></span>
              </a>
              <a href="/" target="_blank" className="mr-6 text-primary-dark">
                <span className="text-lg fab fa-instagram"></span>
              </a>
              <a href="/" target="_blank" className="mr-6 text-primary-dark">
                <span className="text-lg fab fa-pinterest"></span>
              </a>
              <a href="/" target="_blank" className="mr-6 text-primary-dark">
                <span className="text-lg fab fa-github"></span>
              </a>
            </div>
          </div>
          <div className="flex flex-wrap -mx-3">
            <div className="w-8/12 max-w-full px-3 mx-auto mt-1 text-center flex-0">
              <p className="mb-0 text-primary-dark">
                Powered by <a href="https://bigmove.dev">BigMove LLC</a>.
              </p>
            </div>
          </div>
        </div>
      </footer>
      {otpRequired ? <VerifyLoginOTP options={{open, setOpen, toggleSignWithOtpModal, handleSubmit, username:userName, password, ip, browserName}} /> : ''}
    </div>
  );
};

export default SignIn;
